var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pricingScheme seller-style" },
    [
      _c("div", { staticClass: "box20" }),
      _c("div", { staticClass: "b_white bor_radius_10" }, [
        _c("div", { staticClass: "lin_75 f18 gray_3 pad30_l" }, [
          _vm._v("添加价格方案")
        ]),
        _c("div", { staticClass: "ps_main clear" }, [
          _c("p", { staticClass: "ps_main_head" }, [
            _vm._v("温馨提示：最终的价格，以商品列表计算后展示的价格为准")
          ]),
          _c("div", { staticClass: "clear ps_search_wrap" }, [
            _c(
              "span",
              { staticClass: "float-left lin_30 inlineblock w70 gray_3" },
              [_vm._v("名称")]
            ),
            _c(
              "div",
              { staticClass: "ps_search float-left" },
              [
                _c("el-input", {
                  attrs: {
                    type: "text",
                    placeholder: "请输入价格方案",
                    maxlength: "10",
                    "show-word-limit": ""
                  },
                  model: {
                    value: _vm.price.name,
                    callback: function($$v) {
                      _vm.$set(_vm.price, "name", $$v)
                    },
                    expression: "price.name"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "box20" }),
          _c("div", { staticClass: "clear" }, [
            _c(
              "span",
              { staticClass: "float-left lin_30 inlineblock w70 gray_3" },
              [_vm._v("类别")]
            ),
            _c(
              "div",
              { staticClass: "float-left ps_category lin_30" },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 1 },
                    model: {
                      value: _vm.price.schemeType,
                      callback: function($$v) {
                        _vm.$set(_vm.price, "schemeType", $$v)
                      },
                      expression: "price.schemeType"
                    }
                  },
                  [_vm._v("按分组设置")]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: 2 },
                    model: {
                      value: _vm.price.schemeType,
                      callback: function($$v) {
                        _vm.$set(_vm.price, "schemeType", $$v)
                      },
                      expression: "price.schemeType"
                    }
                  },
                  [_vm._v("按客户设置")]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "box20" }),
          _vm.price.schemeType === 1
            ? _c("div", [
                _c("div", { staticClass: "clear pad70_l" }, [
                  _c(
                    "div",
                    { staticClass: "ps_add", on: { click: _vm.chooseGroup } },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v("\n            添加分组\n          ")
                    ]
                  )
                ]),
                _c("div", { staticClass: "ps_group_list pad70_l" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.groupShowList, function(item, index) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeGroup(item)
                            }
                          }
                        }),
                        _c(
                          "p",
                          { staticClass: "group_item_name ellipsis_two" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _c("p", [
                          _vm._v("人群总数：" + _vm._s(item.customerNum))
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm.price.schemeType === 2
            ? _c("div", [
                _c("div", { staticClass: "clear pad70_l" }, [
                  _c(
                    "div",
                    {
                      staticClass: "ps_add",
                      on: { click: _vm.chooseCustomer }
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v("\n            添加客户\n          ")
                    ]
                  )
                ]),
                _c("div", { staticClass: "ps_group_list pad70_l" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerShowList, function(item, index) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeCustomer(item)
                            }
                          }
                        }),
                        _c(
                          "p",
                          { staticClass: "group_item_name ellipsis_two" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _c("p", [
                          _vm._v(
                            "身份：" +
                              _vm._s(item.targetType === 1 ? "个人" : "企业")
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _c("div", { staticClass: "clear" }, [
            _c(
              "span",
              { staticClass: "float-left lin_30 inlineblock w70 gray_3" },
              [_vm._v("选择货品")]
            ),
            _c(
              "div",
              { staticClass: "float-left ps_choose_goods lin_30" },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 11 },
                    model: {
                      value: _vm.price.goodsType,
                      callback: function($$v) {
                        _vm.$set(_vm.price, "goodsType", $$v)
                      },
                      expression: "price.goodsType"
                    }
                  },
                  [_vm._v("全部货品")]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: 21 },
                    model: {
                      value: _vm.price.goodsType,
                      callback: function($$v) {
                        _vm.$set(_vm.price, "goodsType", $$v)
                      },
                      expression: "price.goodsType"
                    }
                  },
                  [_vm._v("指定分类")]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: 31 },
                    model: {
                      value: _vm.price.goodsType,
                      callback: function($$v) {
                        _vm.$set(_vm.price, "goodsType", $$v)
                      },
                      expression: "price.goodsType"
                    }
                  },
                  [_vm._v("指定货品")]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "box20" }),
          _c("div", { staticClass: "pad70_l" }, [
            _vm.price.goodsType === 11
              ? _c("div", { staticClass: "ps_all_goods" }, [
                  _c("span", { staticClass: "gray_3" }, [_vm._v("价格设置")]),
                  _c("span", { staticClass: "pad15_l gray_9" }, [
                    _vm._v("按原价"),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rebate,
                          expression: "rebate"
                        }
                      ],
                      attrs: { type: "text", min: "0", maxlength: "10" },
                      domProps: { value: _vm.rebate },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rebate = $event.target.value
                          },
                          function($event) {
                            _vm.rebate = _vm.formatPrice(_vm.rebate, 2)
                          }
                        ]
                      }
                    }),
                    _vm._v("%，进行售卖\n          ")
                  ])
                ])
              : _vm._e(),
            _vm.price.goodsType === 21
              ? _c("div", [
                  _c("div", { staticClass: "clear" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ps_add",
                        on: { click: _vm.chooseCategory }
                      },
                      [
                        _c("i", { staticClass: "el-icon-plus" }),
                        _vm._v("\n              选择分类\n            ")
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "box20" }),
                  _c("div", { staticClass: "ps_classify_list" }, [
                    _c(
                      "ul",
                      { staticClass: "clear" },
                      _vm._l(_vm.categoryShowList, function(item, index) {
                        return _c(
                          "li",
                          { key: index, staticClass: "ellipsis" },
                          [
                            _c("span", [_vm._v(_vm._s(item.text))]),
                            _c("i", {
                              staticClass: "iconfont icon-shibai fb",
                              on: {
                                click: function($event) {
                                  return _vm.removeCategory(item)
                                }
                              }
                            })
                          ]
                        )
                      }),
                      0
                    ),
                    _c("div", { staticClass: "ps_all_goods" }, [
                      _c("span", { staticClass: "gray_3" }, [
                        _vm._v("价格设置")
                      ]),
                      _c("span", { staticClass: "pad15_l gray_9" }, [
                        _vm._v("按原价"),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rebate,
                              expression: "rebate"
                            }
                          ],
                          attrs: { type: "text", min: "0", maxlength: "10" },
                          domProps: { value: _vm.rebate },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.rebate = $event.target.value
                              },
                              function($event) {
                                _vm.rebate = _vm.formatPrice(_vm.rebate, 2)
                              }
                            ]
                          }
                        }),
                        _vm._v("%，进行售卖\n              ")
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm.price.goodsType === 31
              ? _c(
                  "div",
                  [
                    _c("div", { staticClass: "ps_appoint_goods" }, [
                      _c(
                        "div",
                        {
                          staticClass: "ps_add",
                          on: { click: _vm.chooseGoods }
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v("\n              添加货品\n            ")
                        ]
                      )
                    ]),
                    _vm.goodsPageTotalList.length > 0
                      ? _c("div", { staticClass: "modify_price_wrap" }, [
                          _c("p", [_vm._v("批量修改价格")]),
                          _c(
                            "div",
                            { staticClass: "lin_30 mar10_b" },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.modifyPriceRadio,
                                    callback: function($$v) {
                                      _vm.modifyPriceRadio = $$v
                                    },
                                    expression: "modifyPriceRadio"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("批量加减价格")
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("按折扣修改价格")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.modifyPriceRadio === 1
                            ? _c(
                                "div",
                                { staticClass: "lin_30 mar10_b clear" },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "float-left" },
                                    [
                                      _c("el-input-number", {
                                        staticClass: "mar5_lr",
                                        attrs: {
                                          maxlength: "10",
                                          precision: 2
                                        },
                                        model: {
                                          value: _vm.batch.price,
                                          callback: function($$v) {
                                            _vm.$set(_vm.batch, "price", $$v)
                                          },
                                          expression: "batch.price"
                                        }
                                      }),
                                      _vm._v(" 元")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "float-left mar40_l modify_price_btn",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.batchConfirm }
                                    },
                                    [_vm._v("确 定")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.modifyPriceRadio === 2
                            ? _c(
                                "div",
                                { staticClass: "lin_30 mar10_b clear" },
                                [
                                  _c("p", { staticClass: "float-left" }, [
                                    _vm._v(
                                      "\n                折扣价\n                "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.batch.rebate,
                                          expression: "batch.rebate"
                                        }
                                      ],
                                      staticClass: "mar5_lr",
                                      attrs: {
                                        type: "text",
                                        min: "0",
                                        maxlength: "10"
                                      },
                                      domProps: { value: _vm.batch.rebate },
                                      on: {
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.batch,
                                              "rebate",
                                              $event.target.value
                                            )
                                          },
                                          function($event) {
                                            _vm.batch.rebate = _vm.formatPrice(
                                              _vm.batch.rebate,
                                              2
                                            )
                                          }
                                        ]
                                      }
                                    }),
                                    _vm._v("%\n              ")
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "float-left mar40_l modify_price_btn",
                                      attrs: { type: "primary" },
                                      on: { click: _vm.batchConfirm }
                                    },
                                    [_vm._v("确 定")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "box20" }),
                    _vm.goodsPageList && _vm.goodsPageList.length
                      ? _c(
                          "div",
                          {
                            staticClass: "flex items-center gray6 mar20-b f24"
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "列表展示",
                                  placement: "top"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-s-operation pointer",
                                  class: {
                                    blue: _vm.goodsShowStyle == "table"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.goodsShowStyle = "table"
                                    }
                                  }
                                })
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: "卡片展示",
                                  placement: "top"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-menu mar10-l pointer",
                                  class: { blue: _vm.goodsShowStyle == "card" },
                                  on: {
                                    click: function($event) {
                                      _vm.goodsShowStyle = "card"
                                    }
                                  }
                                })
                              ]
                            ),
                            _vm.goodsShowStyle == "table"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "mar20-l",
                                    attrs: { size: "mini", type: "primary" },
                                    on: { click: _vm.batchDel }
                                  },
                                  [_vm._v("批量删除")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.goodsPageList &&
                    _vm.goodsPageList.length &&
                    _vm.goodsShowStyle == "table"
                      ? _c(
                          "el-table",
                          {
                            ref: "goodsList",
                            attrs: {
                              "header-cell-style": {
                                backgroundColor: "#f8f8f8"
                              },
                              align: "center",
                              data: _vm.goodsPageList
                            },
                            on: {
                              "selection-change": _vm.goodsListSelectionChange
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: { type: "selection", width: "55" }
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "name", label: "货品名称" }
                            }),
                            _c("el-table-column", {
                              attrs: { label: "货品图片" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.picUrl
                                          ? _c("el-image", {
                                              staticClass: "wh60",
                                              attrs: {
                                                "preview-src-list": [
                                                  scope.row.picUrl
                                                ],
                                                src:
                                                  scope.row.picUrl +
                                                  "?imageView2/1/w/60/h/60"
                                              }
                                            })
                                          : _c("img", {
                                              staticClass: "wh60",
                                              attrs: {
                                                src: require("@/assets/images/goods_small.jpg")
                                              }
                                            })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2940695748
                              )
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "spec",
                                label: "规格",
                                width: "200"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "originalPrice",
                                label: "原价",
                                width: "200"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: { label: "方案价格", width: "250" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: scope.row.price,
                                              expression: "scope.row.price"
                                            }
                                          ],
                                          staticStyle: { width: "150px" },
                                          attrs: {
                                            type: "text",
                                            min: "0",
                                            maxlength: "15"
                                          },
                                          domProps: { value: scope.row.price },
                                          on: {
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  scope.row,
                                                  "price",
                                                  $event.target.value
                                                )
                                              },
                                              function($event) {
                                                scope.row.price = _vm.formatPrice(
                                                  scope.row.price,
                                                  6
                                                )
                                              }
                                            ]
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1762565293
                              )
                            }),
                            _c("el-table-column", {
                              attrs: { label: "操作", width: "100" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass: "blue pointer",
                                          on: {
                                            click: function($event) {
                                              return _vm.removeGoods(scope.row)
                                            }
                                          }
                                        },
                                        [_vm._v("删除")]
                                      )
                                    }
                                  }
                                ],
                                null,
                                false,
                                1609452070
                              )
                            })
                          ],
                          1
                        )
                      : _c("div", { staticClass: "appoint_goods_list" }, [
                          _c(
                            "ul",
                            { staticClass: "clear" },
                            _vm._l(_vm.goodsPageList, function(item, index) {
                              return _c(
                                "li",
                                { key: index },
                                [
                                  _c("i", {
                                    staticClass: "iconfont icon-shibai fb",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeGoods(item)
                                      }
                                    }
                                  }),
                                  item.picUrl
                                    ? _c("el-image", {
                                        staticClass:
                                          "float-left appoint_good_img",
                                        attrs: {
                                          src:
                                            item.picUrl +
                                            "?imageView2/1/w/80/h/80",
                                          "preview-src-list": [item.picUrl]
                                        }
                                      })
                                    : _c("img", {
                                        staticClass:
                                          "float-left appoint_good_img",
                                        attrs: {
                                          src: require("@/assets/images/goods_small.jpg"),
                                          alt: ""
                                        }
                                      }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "float-left appoint_good_main"
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "ellipsis_two f14 gray_3",
                                          attrs: { title: item.name }
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _c("p", { staticClass: "f12 gray_6" }, [
                                        _vm._v("规格：" + _vm._s(item.spec))
                                      ]),
                                      _c("p", { staticClass: "f12 gray_6" }, [
                                        _vm._v(
                                          "原价：¥" + _vm._s(item.originalPrice)
                                        )
                                      ]),
                                      _vm._v("\n                  ¥ "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: item.price,
                                            expression: "item.price"
                                          }
                                        ],
                                        attrs: {
                                          type: "text",
                                          min: "0",
                                          maxlength: "15"
                                        },
                                        domProps: { value: item.price },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                item,
                                                "price",
                                                $event.target.value
                                              )
                                            },
                                            function($event) {
                                              item.price = _vm.formatPrice(
                                                item.price,
                                                6
                                              )
                                            }
                                          ]
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ]),
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "hide-on-single-page": _vm.totalCount <= _vm.pageSize,
                        "current-page": _vm.currentPage,
                        "page-size": _vm.pageSize,
                        layout: "total, prev, pager, next, jumper",
                        total: _vm.totalCount
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "box50" })
          ]),
          _c("div", { staticClass: "ps_footer t_center" }, [
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: _vm.disabled },
                    on: { click: _vm.priceSubmit }
                  },
                  [_vm._v("确 认")]
                ),
                _c("el-button", { on: { click: _vm.priceCancel } }, [
                  _vm._v("取 消")
                ])
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择分组",
            visible: _vm.chooseGroupVisible,
            "close-on-click-modal": false,
            width: "445px",
            "show-close": false,
            "custom-class": "chooseGroupPop"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseGroupVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "ps_group_list" }, [
            _c(
              "ul",
              { staticClass: "clear" },
              _vm._l(_vm.groupDataList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: { chooseGroupLi: item.isActive },
                    on: {
                      click: function($event) {
                        return _vm.groupDialogSelect(item)
                      }
                    }
                  },
                  [
                    _c("p", { staticClass: "group_item_name ellipsis_two" }, [
                      _vm._v(_vm._s(item.name))
                    ]),
                    _c("p", [_vm._v("人群总数：" + _vm._s(item.customerNum))])
                  ]
                )
              }),
              0
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.groupDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chooseGroupVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择客户",
            visible: _vm.chooseClientVisible,
            "close-on-click-modal": false,
            width: "735px",
            "show-close": false,
            "custom-class": "chooseClientPop"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseClientVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("客户名称")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.searchCustomer.name,
                      callback: function($$v) {
                        _vm.$set(_vm.searchCustomer, "name", $$v)
                      },
                      expression: "searchCustomer.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "float-left client_pop_query",
                  on: {
                    click: function($event) {
                      return _vm.listCustomer(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ]),
            _c("div", { staticClass: "box30" }),
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("客户分组")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择客户分组", clearable: "" },
                      model: {
                        value: _vm.searchCustomer.groupId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchCustomer, "groupId", $$v)
                        },
                        expression: "searchCustomer.groupId"
                      }
                    },
                    _vm._l(_vm.groupDataList1, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "box20" }),
            _c("div", { staticClass: "clear ps_group_list" }, [
              _c("div", { staticClass: "float-left client_list_all" }, [
                _c("p", [_vm._v("我的客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerDataList, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.customerDialogSelect(item)
                            }
                          }
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "group_item_name ellipsis_two" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _c("p", [
                            _vm._v(
                              "身份：" +
                                _vm._s(item.targetType === 1 ? "个人" : "企业")
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "float-right client_list_me" }, [
                _c("p", [_vm._v("已选客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerSelectList, function(item, index) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeSelectCustomer(item)
                            }
                          }
                        }),
                        _c(
                          "p",
                          { staticClass: "group_item_name ellipsis_two" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _c("p", [
                          _vm._v(
                            "身份：" +
                              _vm._s(item.targetType === 1 ? "个人" : "企业")
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "box20" }),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage1,
              "page-sizes": [6, 20, 30],
              "page-size": _vm.pageSize1,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalCount1
            },
            on: {
              "size-change": _vm.handleSizeChange1,
              "current-change": _vm.handleCurrentChange1
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.customerDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c("el-button", { on: { click: _vm.customerDialogClose } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.chooseGoodVisible,
            "close-on-click-modal": false,
            width: "945px",
            top: "80px",
            "show-close": false,
            "custom-class": "chooseGoodPop"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseGoodVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock gray_3" },
                [_vm._v("货品名称")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入货品名称" },
                    model: {
                      value: _vm.searchGoods.name,
                      callback: function($$v) {
                        _vm.$set(_vm.searchGoods, "name", $$v)
                      },
                      expression: "searchGoods.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "float-left client_pop_query",
                  on: {
                    click: function($event) {
                      return _vm.getPriceGoodsList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ]),
            _c("div", { staticClass: "box30" }),
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock gray_3" },
                [_vm._v("货品分类")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择货品分类", clearable: "" },
                      model: {
                        value: _vm.searchGoods.axis,
                        callback: function($$v) {
                          _vm.$set(_vm.searchGoods, "axis", $$v)
                        },
                        expression: "searchGoods.axis"
                      }
                    },
                    _vm._l(_vm.backgroundCategoryList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.text, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "box20" }),
            _c("div", { staticClass: "clear appoint_goods_list" }, [
              _c("div", { staticClass: "float-left client_list_all" }, [
                _c("p", { staticClass: "gray_3" }, [_vm._v("本店货品")]),
                _c("div", { staticClass: "client_list_wrap" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.goodsDataList, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.goodsDialogSelect(item)
                            }
                          }
                        },
                        [
                          item.picUrl
                            ? _c("img", {
                                staticClass: "float-left appoint_good_img",
                                attrs: { src: item.picUrl, alt: "" }
                              })
                            : _c("img", {
                                staticClass: "float-left appoint_good_img",
                                attrs: {
                                  src: require("@/assets/images/goods_small.jpg"),
                                  alt: ""
                                }
                              }),
                          _c(
                            "div",
                            { staticClass: "float-left appoint_good_main" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "ellipsis_two f14 gray_3",
                                  attrs: { title: item.name }
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _c("p", { staticClass: "f12 gray_6" }, [
                                _vm._v("规格：" + _vm._s(item.spec))
                              ]),
                              _c("p", { staticClass: "f12 gray_6" }, [
                                _vm._v("原价：¥" + _vm._s(item.originalPrice))
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "float-right client_list_me" }, [
                _c("p", { staticClass: "gray_3" }, [_vm._v("已选货品")]),
                _c("div", { staticClass: "client_list_wrap" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.goodsSelectList, function(item, index) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeSelectGoods(item)
                            }
                          }
                        }),
                        item.picUrl
                          ? _c("img", {
                              staticClass: "float-left appoint_good_img",
                              attrs: { src: item.picUrl, alt: "" }
                            })
                          : _c("img", {
                              staticClass: "float-left appoint_good_img",
                              attrs: {
                                src: require("@/assets/images/goods_small.jpg"),
                                alt: ""
                              }
                            }),
                        _c(
                          "div",
                          { staticClass: "float-left appoint_good_main" },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "ellipsis_two f14 gray_3",
                                attrs: { title: item.name }
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _c("p", { staticClass: "f12 gray_6" }, [
                              _vm._v("规格：" + _vm._s(item.spec))
                            ]),
                            _c("p", { staticClass: "f12 gray_6" }, [
                              _vm._v("原价：¥" + _vm._s(item.originalPrice))
                            ])
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "box20" })
          ]),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage2,
              "page-sizes": [10, 20, 30],
              "page-size": _vm.pageSize2,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalCount2
            },
            on: {
              "size-change": _vm.handleSizeChange2,
              "current-change": _vm.handleCurrentChange2
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c("el-button", { on: { click: _vm.goodsDialogClose } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "全部分类",
            visible: _vm.chooseCategoryVisible,
            "close-on-click-modal": false,
            width: "390px",
            "custom-class": "chooseClassifyPop"
          },
          on: {
            "update:visible": function($event) {
              _vm.chooseCategoryVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c(
              "ul",
              { staticClass: "clear" },
              _vm._l(_vm.categoryDataList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: { chooseClassifyActive: item.isActive },
                    on: {
                      click: function($event) {
                        return _vm.categoryDialogSelect(item)
                      }
                    }
                  },
                  [_vm._v("\n          " + _vm._s(item.text) + "\n        ")]
                )
              }),
              0
            )
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.categoryDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chooseCategoryVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }